import { useState } from "react";
import { useTranslation } from "react-i18next";

import CustomButtonLayout from "../layout/CustomButtonLayout";
import TestBarcodeScanDialog from "../dialogTypes/TestBarcodeScanDialog";

function TestBarcodeScanButton(props) {
    const { t } = useTranslation();

    const { id, schema, refresh, onClose, onSuccess, buttonName, barcodeCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onDialogClose = () => {
        setOpen(false);

        if (onClose) {
            onClose();
        }
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <>
            <CustomButtonLayout id={id + "create-button"} onClick={onOpen} buttonName={buttonName} {...others} />
            <TestBarcodeScanDialog
                id={id + "create-dialog"}
                open={open}
                schema={schema}
                onClose={onDialogClose}
                onSuccess={onCreateSuccess}
                barcodeCallback={barcodeCallback}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
            />
        </>
    );
}

export default TestBarcodeScanButton;
